import { SeverityLevel } from '@logz-pkg/enums';
export const severityTag = (theme) => ({
    variants: {
        default: {
            backgroundColor: theme.colors?.severity.debug,
            color: theme.colors?.text.basic.onColor,
        },
        [SeverityLevel.Info]: {
            backgroundColor: theme.colors?.severity.info,
        },
        [SeverityLevel.Low]: {
            backgroundColor: theme.colors?.severity.low,
        },
        [SeverityLevel.Medium]: {
            backgroundColor: theme.colors?.severity.medium,
        },
        [SeverityLevel.High]: {
            backgroundColor: theme.colors?.severity.high,
        },
        [SeverityLevel.Severe]: {
            backgroundColor: theme.colors?.severity.critical,
        },
    },
});
//# sourceMappingURL=severity-tag.js.map